/**
 * InputText component
 * @returns <InputText />
 */
import { useState, useRef } from "react"

const InputText = (props) => {
  const {
    type,
    id,
    name,
    label,
    isRequired,
    placeholder,
    error,
    changed,
    value,
    disabled
  } = props;

  // State
  const [isFocused, setIsFocused] = useState(false);

  // Text
  if (type === "text") {
    return (
      <div className="input">
        <div className={`input__field ${isFocused ? "--focus" : ""} ${value || placeholder ? "--filled" : ""} ${error ? "--invalid" : ""} ${disabled ? "--disabled" : ""}`}>
          <input className={`input__text`} type="text" name={name} required={isRequired ? true : false} value={value} id={id} onChange={changed} placeholder={placeholder ? placeholder : null} onFocus={(e) => setIsFocused(true)} onBlur={(e) => setIsFocused(false)} />
          <label htmlFor={name} className={`input__text__label --floating-label`}>{label}</label>
        </div>

        {/* Optional message */}
        {!isRequired && <p className="message__optional">* Opcional</p>}
        {/* Message box to display a message 
            types: ok, error
        */}
        {error && (
          <div className="input__message--error">
            {/* <img src={imageSrc} alt="" /> */}
            <p>{error}</p>
          </div>
        )}
      </div>
    )
  }
}

export default InputText